<template>
  <div class="free-trial-page">
    <!-- 顶部动画背景 -->
    <div class="animated-bg"></div>

    <!-- 主要内容区 -->
    <div class="container">
      <div class="content-wrapper">
        <!-- 左侧文案 -->
        <div class="left-content" data-aos="fade-right">
          <h1 class="main-title">申请免费试用系统</h1>
          <h2 class="sub-title">即刻获取线上1对1演示或免费体验系统</h2>
          <ul class="benefits-list">
            <li
              v-for="(item, index) in benefits"
              :key="index"
              class="benefit-item"
            >
              <i class="el-icon-check"></i> {{ item }}
            </li>
          </ul>
          <div class="contact-info">
            <p><i class="el-icon-wechat"></i> 微信: 13403922611</p>
            <p><i class="el-icon-phone"></i> 客服热线: 0392-360-5688</p>
            <p><i class="el-icon-time"></i> 工作时间: 周一至周六 8:30-17:30</p>
          </div>
        </div>

        <!-- 右侧表单 -->
<!--        <div class="right-form" data-aos="fade-left">-->
<!--          <el-card class="form-card" shadow="hover">-->
<!--            <div class="form-header">-->
<!--              <h3>填写信息，立即体验</h3>-->
<!--              <p>30秒快速填写，专业顾问将尽快联系您</p>-->
<!--            </div>-->

<!--            <el-form-->
<!--              ref="form"-->
<!--              :model="form"-->
<!--              :rules="rules"-->
<!--              label-position="top"-->
<!--              class="demo-form"-->
<!--              @submit.native.prevent="submitForm"-->
<!--            >-->
<!--              <el-form-item label="姓名" prop="name">-->
<!--                <el-input-->
<!--                  v-model="form.name"-->
<!--                  placeholder="请输入您的姓名"-->
<!--                  prefix-icon="el-icon-user"-->
<!--                >-->
<!--                </el-input>-->
<!--              </el-form-item>-->

<!--              <el-form-item label="联系电话" prop="phone">-->
<!--                <el-input-->
<!--                  v-model="form.phone"-->
<!--                  placeholder="请输入您的联系电话"-->
<!--                  prefix-icon="el-icon-mobile-phone"-->
<!--                >-->
<!--                </el-input>-->
<!--              </el-form-item>-->

<!--              <el-form-item label="企业名称" prop="company">-->
<!--                <el-input-->
<!--                  v-model="form.company"-->
<!--                  placeholder="请输入您的企业名称"-->
<!--                  prefix-icon="el-icon-office-building"-->
<!--                >-->
<!--                </el-input>-->
<!--              </el-form-item>-->

<!--              <el-form-item label="您的职位" prop="position">-->
<!--                <el-input-->
<!--                  v-model="form.position"-->
<!--                  placeholder="请输入您的职位"-->
<!--                  prefix-icon="el-icon-suitcase"-->
<!--                >-->
<!--                </el-input>-->
<!--              </el-form-item>-->

<!--              <el-form-item>-->
<!--                <el-button-->
<!--                  type="primary"-->
<!--                  native-type="submit"-->
<!--                  class="submit-btn"-->
<!--                  :loading="loading"-->
<!--                >-->
<!--                  立即提交 联系我们-->
<!--                </el-button>-->
<!--              </el-form-item>-->

<!--              &lt;!&ndash; <div class="form-footer">-->
<!--                <p>提交即表示您同意我们的 <a href="#">隐私政策</a></p>-->
<!--              </div> &ndash;&gt;-->
<!--            </el-form>-->
<!--          </el-card>-->
<!--        </div>-->
      </div>
    </div>

    <!-- 底部装饰 -->
    <div class="bottom-decoration"></div>
  </div>
</template>

<script>
import "aos/dist/aos.css";
import AOS from "aos";
import Axios from "axios";

export default {
  name: "FreeTrialPage",
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入联系电话"));
      }
      setTimeout(() => {
        if (!/^1[3-9]\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号码"));
        } else {
          callback();
        }
      }, 300);
    };

    return {
      loading: false,
      form: {
        name: "",
        company: "",
        position: "",
        phone: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        company: [
          { required: false, message: "请输入企业名称", trigger: "blur" },
        ],
        position: [
          { required: false, message: "请输入您的职位", trigger: "blur" },
        ],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
      },
      benefits: [
        "专业顾问1对1演示讲解",
        "7天免费全功能体验",
        "无需下载，在线体验",
        "资深团队为您服务",
      ],
    };
  },
  mounted() {
    // 初始化动画库
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });

    // 设置Element主题色
    document.documentElement.style.setProperty("--el-color-primary", "#f97d01");
  },
  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 模拟API请求
          Axios.post("http://192.168.1.31:8067/system/contactUs/add", {
            companyName: this.form.company,
            position: this.form.position,
            name: this.form.name,
            phone: this.form.phone,
          })
            .then(() => {
              this.$message.success("提交成功！我们的顾问将尽快联系您");
              this.$refs.form.resetFields();
            })
            .catch(() => {
              this.$message.error("提交失败，请稍后重试");
            })
            .finally(() => {
              this.loading = false;
            });
          // setTimeout(() => {
          //   this.loading = false;
          //   this.$message.success("提交成功！我们的顾问将尽快联系您");
          //   this.$refs.form.resetFields();
          // }, 1500);
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
/* 全局主题色 */
$primary-color: #f97d01;
$primary-light: lighten($primary-color, 35%);

.free-trial-page {
  min-height: 100vh;
  background-color: #f9f9f9;
  position: relative;
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    Arial, sans-serif;

  .animated-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 400px;
    background: linear-gradient(135deg, $primary-light, #fff);
    z-index: 0;
    animation: gradientShift 8s ease infinite;
    background-size: 200% 200%;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 60px 20px;
    position: relative;
    z-index: 1;
  }

  .content-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }

  .left-content {
    flex: 1;
    min-width: 300px;
    padding: 60px 40px;
    background: linear-gradient(
      to bottom right,
      $primary-color,
      darken($primary-color, 10%)
    );
    color: #fff;

    .main-title {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 20px;
      line-height: 1.3;
    }

    .sub-title {
      font-size: 18px;
      font-weight: 400;
      margin-bottom: 40px;
      opacity: 0.9;
    }

    .benefits-list {
      list-style: none;
      padding: 0;
      margin-bottom: 50px;

      .benefit-item {
        margin-bottom: 15px;
        font-size: 16px;
        display: flex;
        align-items: center;

        i {
          margin-right: 10px;
          font-size: 18px;
          color: #fff;
        }
      }
    }

    .contact-info {
      margin-top: 40px;
      font-size: 14px;

      p {
        margin-bottom: 10px;
        display: flex;
        align-items: center;

        i {
          margin-right: 8px;
          font-size: 16px;
        }
      }
    }
  }

  .right-form {
    flex: 1;
    min-width: 300px;
    padding: 40px;

    .form-card {
      border: none;
      box-shadow: none;

      .form-header {
        text-align: center;
        margin-bottom: 30px;

        h3 {
          font-size: 24px;
          color: #333;
          margin-bottom: 10px;
        }

        p {
          color: #999;
          font-size: 14px;
        }
      }

      .el-form-item__label {
        font-weight: 500;
        color: #666;
        padding-bottom: 5px;
      }

      .el-input__inner {
        height: 48px;
        line-height: 48px;
      }

      .el-input__prefix {
        display: flex;
        align-items: center;
        left: 10px;
      }

      .submit-btn {
        width: 100%;
        height: 48px;
        background-color: $primary-color;
        border: none;
        font-size: 16px;
        transition: all 0.3s;

        &:hover {
          background-color: darken($primary-color, 8%);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba($primary-color, 0.3);
        }
      }

      .form-footer {
        text-align: center;
        margin-top: 20px;
        font-size: 12px;
        color: #999;

        a {
          color: $primary-color;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .bottom-decoration {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none"><path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="%23f97d01"></path><path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" fill="%23f97d01"></path><path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="%23f97d01"></path></svg>')
      no-repeat center bottom;
    background-size: cover;
    z-index: 0;
  }
}

/* 动画效果 */
@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
  }

  .left-content,
  .right-form {
    padding: 30px 20px;
  }

  .left-content {
    order: 2;
  }

  .right-form {
    order: 1;
  }
}
</style>